import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Table, Spin, Icon, Select, Modal, DatePicker, Divider, Notification, Popover, Switch } from 'ant-design-vue'
import Vuelidate from 'vuelidate'

Vue.config.productionTip = false
Vue.component(Table.name, Table)
Vue.component(Table.Column.name, Table.Column)
Vue.component(Icon.name, Icon)
Vue.component(Select.name, Select)
Vue.component(Select.Option.name, Select.Option)
Vue.component(Modal.name, Modal)
Vue.component(DatePicker.name, DatePicker)
Vue.component(Divider.name, Divider)
Vue.component(Switch.name, Switch)
Vue.prototype.$notification = Notification;
Vue.component(Popover.name, Popover)
Vue.use(Vuelidate)

Spin.setDefaultIndicator({
  indicator: h => {
    return <a-icon type="loading" />
  },
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
